module.exports = __webpack_public_path__ + "static/img/dsk-about-bg.a25e9f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dsk-about-bg.jpg
// module id = 225
// module chunks = 1